import React from 'react';
import { useColorScheme } from '../../contexts/ColorSchemeContext';
import { profileMarkData as data } from '../../components/content/profileMarkData';
import { badgeIconOffsetByKey } from './generated/offsets';
export function BadgeIcon({ badge, size = 40, muted = false }) {
  const { resolvedMode } = useColorScheme(),
    dark = resolvedMode === 'dark',
    tier = badge.tier === 2 || badge.tier === 3 ? badge.tier : (data.tiers[badge.key] ?? 1);
  const [background, color] = muted
    ? [dark ? '#2C2927' : '#F1F0EF', '#8D8883']
    : tier === 3
      ? [dark ? '#2F2940' : '#F0EEEB', dark ? '#B79AF5' : '#8064C9']
      : tier === 2
        ? [dark ? '#1F3044' : '#F0EEEB', dark ? '#7FB0E4' : '#3976B9']
        : [dark ? '#3A241D' : '#F0EEEB', dark ? '#FF8A63' : '#F16438'];
  const icon =
      data.maps.key[badge.key] ||
      data.maps.iconKey[badge.iconKey] ||
      data.maps.category[badge.category] ||
      'Award',
    offset = badgeIconOffsetByKey[badge.key] ?? {},
    iconSize = Math.max(9, size * 0.75);
  return (
    <span
      aria-hidden="true"
      className="pp-badge-icon"
      style={{ width: size, height: size, background, color }}
    >
      <svg
        width={iconSize}
        height={iconSize}
        style={{
          transform: `translate(${((offset.x ?? 0) * iconSize) / 24}px,${((offset.y ?? 0) * iconSize) / 24}px)`,
        }}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {(data.icons[icon] || []).map(([tag, props], i) =>
          React.createElement(tag, { ...props, key: i }),
        )}
      </svg>
    </span>
  );
}
export function SupportMark({ level = 0, size = 56, muted = level <= 0 }) {
  const { resolvedMode } = useColorScheme(),
    dark = resolvedMode === 'dark';
  const [background, border, color, accent] = muted
    ? [dark ? '#302D2A' : '#E1DDD9', dark ? '#4A4540' : '#CFC9C3', dark ? '#928B84' : '#77716B']
    : level >= 5
      ? ['#0D0C0B', '#2C2924', '#E8BE58', '#D6A83F']
      : level === 4
        ? ['#CCA64C', '#B68D32', '#18130B']
        : level === 3
          ? ['#B86F44', '#9C5835', '#17120F']
          : level === 2
            ? ['#11100F', '#302C29', '#F16438']
            : ['#F16438', '#D94E25', '#FFFFFF'];
  return (
    <span
      className="pp-badge-support-mark"
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.38,
        background,
        color,
        borderColor: border,
      }}
    >
      <svg height={size * 0.72} viewBox="0 0 485 690">
        <path d={data.path} fill="currentColor" fillRule="evenodd" />
      </svg>
      {accent && <i style={{ background: accent, width: size * 0.88 }} />}
    </span>
  );
}
